module.exports = __webpack_public_path__ + "img/bgf 2025.51957c7a.webp";